import React from 'react';
import styled from 'styled-components';
import { AiFillExclamationCircle } from 'react-icons/ai';

import { useScreenQuery } from 'playup-web-core';

import formatCurrency from '../../../../utils/formatCurrency';
import { DepositResultMessageContainer, ResultAmount, ResultText, StyledButton } from './DepositSuccessfulMessage';

const DepositUnsuccessfulMessage = ({
	amount,
	errorMessage,
	close,
	tryAgain,
	isOnboarding,
}: DepositUnsuccessfulMessageProps) => {
	const { isSmall } = useScreenQuery();

	return (
		<DepositResultMessageContainer>
			<StyledAiFillExclamationCircle size={75} />
			<ResultText isSmallScreen={isSmall}>Deposit Unsuccessful</ResultText>
			<ResultAmount>{formatCurrency(amount)}</ResultAmount>
			{errorMessage && <ErrorText>Reason: {errorMessage}</ErrorText>}
			<StyledButton kind={'white'} onClick={tryAgain}>
				Try Again
			</StyledButton>
			{isOnboarding && (
				<>
					<DepositLaterText onClick={close}>Deposit later</DepositLaterText>
				</>
			)}
		</DepositResultMessageContainer>
	);
};

export default DepositUnsuccessfulMessage;

interface DepositUnsuccessfulMessageProps {
	amount: number;
	errorMessage?: any;
	close: () => void;
	tryAgain: () => void;
	isOnboarding?: boolean;
}

const StyledAiFillExclamationCircle = styled(AiFillExclamationCircle)(({ theme }) => ({
	color: theme.colors.danger,
	margin: '20px 0',
}));

const ErrorText = styled.p(({ theme }) => ({
	fontSize: '11px',
	color: theme.colors.danger,
}));

const DepositLaterText = styled.p({
	textDecoration: 'underline',
	fontSize: '12px',
	cursor: 'pointer',
});
